module.exports = __webpack_public_path__ + "media/images/video-invite-icon-019a74d61fd56f1caedd90e7b5263192249b847eaed5b78bab1d92748b733b4d.svg";